import { Box, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { IAllAnnouncement } from '../../models/announcement.model';
import routes from "../../pages/routes";
import registrationService from '../../services/registration.service';

const AnnouncementSideNav = () => {
  // const [announcements, setAnnouncements] = useState([]);
  const [announcements, setAnnouncements] = useState<IAllAnnouncement[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    registrationService.getAnnouncements().then((res) => {
      setAnnouncements(res.Announcements);
      setIsLoading(false);
    });
  }, []);

  const viewAnnouncement = (announcement_id : string) => {
    navigate(routes.ViewAnnouncementLink(announcement_id));
  };

  const activeLink = (link : string) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (link === location.pathname) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };

  return (
    <Box
      py="40px"
      fontSize="14px"
      bg="white"
      mr="30px"
      minHeight="225px"
      height="fit-content"
      width="16rem"
    >
      <Text pl="40px" mb="20px" fontWeight="700" fontSize="16px" color="red">
        More Announcements
      </Text>
      {!isLoading && announcements.map((announcement, index) => (
        <Box
          key={index}
          pl="40px"
          mb="20px"
          pr="20px"
          borderLeft={activeLink(routes.ViewAnnouncementLink(announcement.uuid)).borderLeft}
          borderColor={activeLink(routes.ViewAnnouncementLink(announcement.uuid)).borderColor}
          bg={activeLink(routes.ViewAnnouncementLink(announcement.uuid)).bgColor}
          color={activeLink(routes.ViewAnnouncementLink(announcement.uuid)).textColor}
          cursor="pointer"
          onClick={() => viewAnnouncement(announcement.uuid)}
        >
           
          <Text fontWeight="600" fontSize="14px" mb="4px">
            {announcement.title}
          </Text>
          <Text fontWeight="500" fontSize="12px" color="red">
            {new Date(announcement.created_at).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </Text>
         
        </Box>
      ))}
    </Box>
  );
};

export default AnnouncementSideNav;
